<template>
    <div>
        <div class="displayBox"> 

            <div class="text" style="margin: 0 0 0 0;">

                <!-- <p class="big">중랑구 시설관리 공단에서 제공하는</p>
                <p class="big">다양한 주차 서비스를 경험하세요.</p>
                <p id="sub" class="sub">중랑구 시설관리 공단은 차량별 월 정기주차 서비스 이외</p>
                <p class="sub">주변 상권을 위한 시간권 구매 서비스를 제공하고 있습니다.</p> -->

                <p class="big">원활한 교통소통과 주차질서 확립을 위해</p>
                <p class="big">항상 노력하는 광명시 공영주차장 입니다.</p>
                <!-- <p id="sub" class="sub">중랑구 시설관리 공단은 차량별 월 정기주차 서비스 이외</p>
                <p class="sub">주변 상권을 위한 시간권 구매 서비스를 제공하고 있습니다.</p> -->
                
            </div>

            <el-row class="centerButton2" with="100%" style="padding: 3vh 0 3vh 0">
                <!-- <div class="Btn1">
                    <p class="bigB">월 정기 주차 신청 서비스</p>
                    <p class="smallB">월 정기 주차 신청은 선택한 주차장에</p>
                    <p class="smallB">일정기간 주차를 신청하는 서비스 입니다.</p>
                    <router-link :to="{name: '확인'}">
                        <img class="btnImg1" src="@/components/image/Month.png"/>
                        <el-button round class="Btn1" @click="defaultActive">바로가기</el-button>
                    </router-link>
                </div> -->
                <div class="BtnFirst">
                    <p class="bigB">주차요금 안내</p>
                    <!-- <p class="smallB">중랑구 시설관리공단에서 운영하는</p> -->
                    <p class="smallB">광명도시공사에서 운영하는</p>
                    <p class="smallB">주차장 요금에 대하여 안내 합니다.</p>
                    <hr class="mobileLine"/>
                    <router-link :to="{name: '요금안내'}">
                        <img class="btnImg1" src="@/components/image/Info.png"/>
                        <el-button round id="Btn1" class="Btn1" @click="defaultActive">바로가기</el-button>
                    </router-link>
                </div>
                <!-- <div class="Btn2">
                    <p class="bigB">시간권 구매 서비스</p>
                    <p class="smallB">상점방문 고객의 주차편의를 위해</p>
                    <p class="smallB">상점에서 고객에게 제공하는 시간권 입니다.</p>
                    <router-link :to="{name: '정보'}">
                        <img class="btnImg2" src="@/components/image/Time.png"/>
                        <el-button round class="Btn2" @click="defaultActive">바로가기</el-button>
                    </router-link>
                </div> -->
                <div class="BtnSecond">
                    <p class="bigB">월 정기 주차 신청 서비스</p>
                    <p class="smallB">월 정기 주차 신청은 선택한 주차장에</p>
                    <p class="smallB">일정기간 주차를 신청하는 서비스 입니다.</p>
                    <hr class="mobileLine"/>
                    <router-link :to="{name: '확인'}">
                        <img class="btnImg2" src="@/components/image/Month.png"/>
                        <el-button round id="Btn2" class="Btn2" @click="defaultActive">바로가기</el-button>
                    </router-link>
                </div>
                <!-- <div class="Btn3">
                    <p class="bigB">주차 미납 요금 검색</p>
                    <p class="smallB">주차장에서 요금을 지불하지 못하고</p>
                    <p class="smallB">출차한 차량에 대하여 검색할 수 있습니다.</p>
                    <router-link :to="{name: '미납정보' }">
                        <img class="btnImg3" src="@/components/image/search.png"/>
                        <el-button round class="Btn3" @click="defaultActive">바로가기</el-button>
                    </router-link>
                </div> -->
                <!-- <div class="BtnThird">
                    <p class="bigB">실시간 주차 현황</p>
                    <p class="smallB">각 주차장 별 주차된 차량의</p>
                    <p class="smallB">현황에 대한 정보를 확인 합니다.</p>
                    <hr class="mobileLine"/>
                    <router-link :to="{name: '실시간정보' }">
                        <img class="btnImg3" src="@/components/image/search.png"/>
                        <el-button round id="Btn3" class="Btn3" @click="defaultActive">바로가기</el-button>
                    </router-link>
                </div> -->

                <div class="BtnThird">
                    <p class="bigB">주차장 위치 안내</p>
                    <!-- <p class="smallB">중랑구 시설관리공단에서 운영하는</p> -->
                    <p class="smallB">광명도시공사에서 운영하는</p>
                    <p class="smallB">주차장의 위치에 대하여 안내합니다</p>
                    <hr class="mobileLine"/>
                    <router-link :to="{name: '안내사항' }">
                        <img class="btnImg3" src="@/components/image/infoParklog.png"/>
                        <el-button round id="Btn3" class="Btn3" @click="defaultActive">바로가기</el-button>
                    </router-link>
                </div>

            </el-row>  
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            startEvent: false,
            moveEvent: false,
            mobileTouch: true,
            checkMobile: false
        }
    },
    methods: {
        defaultActive() {
            this.$store.isActive = false
            this.$store.isSubmit = false
        },
        // onStart() {
        //     this.startEvent = true;
        // },
        // onMove(){
        //     if(!this.startEvent) {
        //         return;
        //     }
        //     this.moveEvent = true
        // },
        isMobile() {
            var user = navigator.userAgent;

            // console.log(user)

            if( user.indexOf("iPhone") > -1 
                || user.indexOf("Android") > -1 
                || user.indexOf("iPad") > -1
                || user.indexOf("iPod") > -1
            ) {
                this.checkMobile = true;
            }
        },
        routerLink() {

            const parkInfo = document.getElementById("Btn1");
            const seasonInfo = document.getElementById("Btn2");
            const timeStampInfo = document.getElementById("Btn3");

            /* 초기화 */
            document.addEventListener('touchstart', (e) => {
                e.preventDefault();
                // e.stopPropagation();

                this.startEvent = true;
            },{passive: false});

            document.addEventListener('touchmove', (e) => {
                e.preventDefault();
                // e.stopPropagation();

                if(!this.startEvent) {
                    return;
                }
                this.moveEvent = true
                
            },{passive: false});

            //router
            parkInfo.addEventListener('click', () => {

                this.$store.isActive = false
                this.$store.isSubmit = false

                if(!this.checkMobile || this.mobileTouch) {
                    this.$router.push({name: '요금안내'});
                }
                
                

            }, false)

            seasonInfo.addEventListener('click', () => {


                this.$store.isActive = false
                this.$store.isSubmit = false
                if(!this.checkMobile || this.mobileTouch) {
                    this.$router.push({name: '확인'});
                }
                

            }, false)

            timeStampInfo.addEventListener('click', () => {


                this.$store.isActive = false
                this.$store.isSubmit = false

                if(!this.checkMobile || this.mobileTouch) {
                    this.$router.push({name: '안내사항'});
                }
                
                
            }, false)
        }
    },
    mounted() {
        this.routerLink();

        this.isMobile();

        window.addEventListener('touchmove', () => {
            this.mobileTouch = false;
        });

        window.addEventListener('touchstart', () => {
            this.mobileTouch = true;
        });

        window.addEventListener('touchcancel', () => {
            this.mobileTouch = true;
        });

        window.addEventListener('touchend', () => {
            this.mobileTouch = true;
        });
    },
    unmounted() {

        window.removeEventListener('touchmove', () => {});
        window.removeEventListener('touchstart', () => {});
        window.removeEventListener('touchcancel', () => {});
        window.removeEventListener('touchend', () => {});

    }
}
</script>

<style scoped>
@import '@/assets/css/reset.css';

    .mobileLine {
        display: none;
    }

    .displayBox {
        display: block;
        margin: auto;
        margin-top: 22vh;
        text-align: center;
        width: 1200px !important;
        height: auto;
    }
    /* 글자 */
    .text {
        margin: 8% 0 0 0;
        text-align: center;
    }

    .big {
        font: normal normal 500 36px/52px Noto Sans KR;
        letter-spacing: 0px;
        color: #000000;
    }

    #sub {
        margin-top: 2%;
    }

    .sub {
        font: normal normal 300 24px/35px Noto Sans KR;
        letter-spacing: 0px;
        color: #000000;
    }

    .bigB {
        margin-top: 3vh;
        margin-bottom: 3%;
        font: normal normal 30px/44px Noto Sans KR-BOLD;
        letter-spacing: -0.75px;
        color: #FFFFFF;
    }

    .smallB {
        font: normal normal 300 18px/26px Noto Sans KR;
        letter-spacing: -0.45px;
        color: #FFFFFF;
    }
    
    .centerButton2 {
        /* margin: 3% 0 3% 0; */
        text-align: center;
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
    }

    .BtnFirst {
        width: 100%;
        background: #35A6D0 0% 0% no-repeat padding-box;
        color: #35A6D0;
        margin-right: 3%;
    }

    .BtnSecond {
        background: #358ED0 0% 0% no-repeat padding-box;
        color: #358ED0;
        margin-right: 3%;
    }

    .BtnThird {
        background: #266CB5 0% 0% no-repeat padding-box;
        color: #266CB5;

    }

    .Btn1 {
        color: #35A6D0;
    }

    .Btn2 {
        color: #358ED0;
    }

    .Btn3 {
        color: #266CB5;
    }

    .el-row >>> div {
        width: 35%;
        height: 100%;
        padding-bottom: 3vh;
    }

    /* .el-row::before {
        display: flex;
    }

    .el-row::after {
        display: flex;
    } */

    .btnImg1 {
        float: left;
        margin-top: 10%;
        margin-left: 30%;
    }

    /* .btnImg2 {
        float: left;
        margin-top: 10%;
        margin-left: 30.5%;
    } */

    .btnImg2 {
        float: left;
        margin-top: 10%;
        margin-left: 29%;
    }

    .btnImg3 {
        float: left;
        margin-top: 10%;
        margin-left: 30.5%;
    }

    .el-button {
        width: 45%;
        height: 50%;
        margin-top: 3vh;
        margin-left: 3.2%;
        padding: 2%;
        font: normal normal 300 20px/29px Noto Sans KR;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        display: inline-block;
    }
    .el-button:hover {
        color: #363636;
        background-color: #a4d2dd;
    }

    
    /* @media all and (max-width: 1536px) {

        .btnImg2 {
            margin-top: 4%;
        }

    } */

    @media all and (max-width: 1200px) {

        .displayBox {
            width: 100vw !important;
            height: 100vh;
        }

        .text {
            width: 100vw;
            margin-top: 15vh !important;
        }

        .centerButton2 {
            margin-top: 0%;
            padding-top: 2% !important;
        }

        .bigB {
            margin-top: 4% !important;
            padding-top: 3% !important;
        }

        .smallB {
            display: none;
        }

        .el-row >>> div {
            width: 24%;
            padding-bottom: 3vh;
        }

        .BtnFirst {
            margin-left: 4.2%;
        }

        .el-button {
            margin-top: 6%;
            margin-left: 0.5%;
            width: 50%;
        }

        .text {
            width: 100vw;
            margin-top: 5% !important;
        }
    

        .BtnFirst {
            margin-left: 1% !important;
            margin-right: 1% !important;
            width: 100% !important;
        }

        .BtnSecond {
            margin-left: 0% !important;
            margin-right: 1% !important;
            width: 100% !important;
        }
        
        .BtnThird {
            margin-left: 0% !important;
            margin-right: 1% !important;
            width: 100% !important;
        }
        
        .btnImg1 {
            margin-bottom: 6.5%;
        }

        .btnImg2 {
            /* margin-top: 3.6%; */
            /* margin-left: 30%; */
            margin-bottom: 6.5%;
        }

        .btnImg3 {
            /* margin-top: 13% !important; */
            margin-left: 25.5%;
            margin-bottom: 6.5%;
        }

        .Btn1 {
            margin-top: 0 !important;
            margin-bottom: 0;
        }
        .Btn2 {
            margin-top: 0 !important;
            margin-bottom: 0;
        }

        .Btn3 {
            margin-top: 0 !important;
            margin-bottom: 0;
        }
    }


    /* 모바일 모드 기본 */
    @media all and (max-width: 1024px) {

        .text {
            margin-top: 18% !important;
        }

        .bigB {
            font: normal normal 24px/44px Noto Sans KR-BOLD;
        }

        .btnImg1 {
            margin-top: 3.5% !important;
        }

        .btnImg2 {
            margin-top: 3.5% !important;
            margin-left: 25% !important;
        }

        .btnImg3 {
            margin-top: 3.5% !important;
        }
        
    }

    /* 모바일 모드 기본 */
    @media all and (max-width: 748px) {

        .el-row >>> div {
            padding-bottom: 5%;
        }

        .text {
            width: 100vw;
            margin-top: 7.5vh !important;
            /* margin-top: 0 !important; */
        }

        .displayBox {
            width: 100vw !important;
            margin-top: 0 !important;
            padding-top: 6vh;
        }

        .big {
            height: auto;
            font: normal normal 17px/40px Noto Sans KR-BOLD;
            color: #000000;
        }

        .sub {
            display: none;
        }

        .centerButton2 {
            display: block;
        }
        
        .bigB {
            margin-top: 4% !important;
            padding-top: 3% !important;
            font: normal normal 20px/44px Noto Sans KR-BOLD;
        }

        .BtnFirst {
            margin-left: 5.5% !important;
            width: 90% !important;
        }

        .btnImg1 {
            display: none;
        }

        .el-button.is-round {
            border-radius: 10px;
        }

        .Btn1 {
            margin-top: 0 !important;
            margin-bottom: 0;
        }

        .BtnSecond {
            margin-left: 5.5% !important;
            width: 90% !important;
        }

        .btnImg2 {
            display: none;
        }

        .Btn2 {
            margin-top: 0 !important;
            margin-bottom: 0;
        }

        .BtnThird {
            margin-left: 5.5% !important;
            width: 90% !important;
        }

        .btnImg3 {
            display: none;
        }

        .Btn3 {
            margin-top: 0 !important;
            margin-bottom: 0;
        }

        .mobileLine {
            display: block;
            width: 85%;
            border: 1px solid #FFFFFF;
            margin-bottom: 5%;
        }

    }
    

    /* 높이 반응형 css */

    /* 노트북 1536 * 864 */
    @media all and (max-height: 864px) {

        .btnImg1 {
            margin-top: 6%;
        }

        .btnImg2 {
            margin-top: 6%;
        }

        .btnImg3 {
            margin-top: 6%;
        }
    }

    @media all and (max-height: 745px) {

        .sub {
            display: none;
        }

        .text {
           padding-top: 3% !important;
           /* padding-bottom: 1% !important; */
        }
        
    }

    @media all and (max-height: 630px) {

        .text {
            padding-top: 1vh !important;
        }

        .smallB {
            display: none;
        }
        
    }

    @media all and (max-height: 565px) {

        .btnImg1 {
            display: none;
        }

        .btnImg2 {
            display: none;
        }
        
        .btnImg3 {
            display: none;
        }

        .el-button {
            margin-top: 1vh;
            font: normal normal 300 18px/29px Noto Sans KR;
        }

        .text {
            padding-top: 1vh !important;
            padding-bottom: 2% !important;
        }

        .mobileLine {
            display: block;
            width: 85%;
            border: 1px solid #FFFFFF;
            margin-bottom: 5%;
        }
        
    }

</style>